import { InformationByMemberLevelType } from './types';

export const informationByMemberLevelList: InformationByMemberLevelType[] = [
  {
    en: 'Owner',
    kr: '소유자',
    description: '구성원 편집을 포함하여 이 채널을 수정할 수 있는 모든 권한을 가져요',
    tooltip: [
      {
        id: 'ownerEditContent',
        content: '✅ 콘텐츠 편집'
      },
      {
        id: 'ownerCreateContent',
        content: '✅ 콘텐츠 생성'
      },
      {
        id: 'ownerDeleteContent',
        content: '✅ 콘텐츠 삭제'
      },
      {
        id: 'ownerPublishContent',
        content: '✅ 콘텐츠 출시 관리'
      },
      {
        id: 'ownerUpdateMember',
        content: '✅ 팀 구성원 추가 / 편집'
      },
      {
        id: 'ownerEditChannelInfo',
        content: '✅ 채널 정보 편집'
      },
      {
        id: 'ownerPlayContent',
        content: '✅ 앱 > 만든 콘텐츠에서 플레이 가능'
      }
    ]
  },
  {
    en: 'Author',
    kr: '편집자',
    description: '새 콘텐츠를 생성하거나 콘텐츠를 편집할 수 있어요 ',
    tooltip: [
      {
        id: 'authorEditContent',
        content: '✅ 콘텐츠 편집'
      },
      {
        id: 'authorCreateContent',
        content: '✅ 콘텐츠 생성'
      },
      {
        id: 'authorDeleteContent',
        content: '❌ 콘텐츠 삭제'
      },
      {
        id: 'authorPublishContent',
        content: '❌ 콘텐츠 출시 관리'
      },
      {
        id: 'authorUpdateMember',
        content: '❌ 팀 구성원 추가 / 편집'
      },
      {
        id: 'authorEditChannelInfo',
        content: '❌ 채널 정보 편집'
      },
      {
        id: 'authorPlayContent',
        content: '✅ 앱 > 만든 콘텐츠에서 플레이 가능'
      }
    ]
  },
  {
    en: 'Tester',
    kr: '테스터',
    description: '리얼월드 앱 ‘내 콘텐츠 > 만든 콘텐츠’에서 콘텐츠를 테스트 할 수 있어요 ',
    tooltip: [
      {
        id: 'testerPlayContent',
        content: '✅ 앱 > 만든 콘텐츠에서 플레이 가능'
      },
      {
        id: 'testerNoChannelHome',
        content: '❌ 채널 홈 접근 불가'
      }
    ]
  }
];
